<div data-testid="paginationControl" class="btn-group" *ngIf="pagination.Pages > 1">
  <button
    type="button"
    (click)="previousClicked()"
    data-testid="prevButton"
    class="btn btn-pagination"
    [disabled]="pagination.Page === 1 || pagination.Pages === 0">
    <i class="fas fa-chevron-left"></i>
  </button>
  <ng-container *ngFor="let page of pageArray">
    <button disabled type="button" class="btn btn-ellipses" *ngIf="showElipsesBeforeButton(page)">
      ...
    </button>
    <button
      type="button"
      (click)="goToPage(page)"
      class="btn btn-pagination"
      [class.active]="page === pagination.Page"
      *ngIf="showPageButton(page)">
      {{ page }}
    </button>
  </ng-container>
  <button
    type="button"
    data-testid="nextButton"
    (click)="nextClicked()"
    class="btn btn-pagination"
    [disabled]="pagination.Page === pagination.Pages || pagination.Pages === 0">
    <i class="fas fa-chevron-right"></i>
  </button>
</div>
